import DatetimeInput from "./datetime-input.js";
import Droplist from "./droplist.js";
import { post } from "./request.js";
import Icon from "./icon.js";

const { redom } = window;
const { el } = redom;

export default class Reserve {
  constructor({ api, app, i18n }) {
    this.api = api;
    this.app = app;
    this.i18n = i18n;
    this.phase = 1;
    this.el = el(
      ".reserve-wrapper",
      el(
        ".reserve",
        (this.content = el(
          ".reserve-content",
          (this.form = el(
            "form.form",
            el(
              ".field",
              el("p", (this.contactDetailsText = el("b"))),
              el("br"),
              el(
                ".row",
                el(
                  ".col2",
                  (this.firstNameText = el("label")),
                  (this.firstName = el("input.input", {
                    id: "reserve-firstname",
                    autocomplete: "off",
                  }))
                ),
                el(
                  ".col2",
                  (this.lastNameText = el("label")),
                  (this.lastName = el("input.input", {
                    id: "reserve-lastname",
                    autocomplete: "off",
                  }))
                )
              ),
              el(
                ".row",
                el(
                  ".col2",
                  (this.emailText = el("label")),
                  (this.email = el("input.input", {
                    id: "reserve-email",
                    disabled: true,
                    autocomplete: "off",
                  }))
                ),
                el(
                  ".col2",
                  (this.phoneText = el("label")),
                  (this.phone = el("input.input", {
                    id: "reserve-phone",
                    autocomplete: "off",
                  }))
                )
              ),
              (this.errors = el(".errors", {
                style: { color: "red", padding: "1rem 0" },
              })),
              el(
                "div",
                { style: { textAlign: "right" } },
                (this.cancel = el(
                  "button.button.circle.grey",
                  { type: "reset" },
                  new Icon("arrow-left")
                )),
                (this.submitButton = el(
                  "button.button.circle",
                  { type: "submit" },
                  new Icon("arrow-right")
                ))
              )
            )
          )),
          (this.form2 = el(
            "form.form",
            el(
              ".field",
              el("p", (this.reservationDetailsText = el("b"))),
              el("br"),
              el(
                ".row",
                el(
                  ".col2",
                  (this.startDatetimeText = el("label")),
                  (this.startDatetime = new DatetimeInput({
                    input: {
                      id: "reserve-startdatetime",
                    },
                    i18n,
                    value: new Date(),
                  }))
                ),
                el(
                  ".col2",
                  (this.endDatetimeText = el("label")),
                  (this.endDatetime = new DatetimeInput({
                    input: {
                      id: "reserve-enddatetime",
                    },
                    i18n,
                    value: new Date(),
                  }))
                )
              ),
              el(
                ".row",
                el(
                  ".col2",
                  (this.activitytypeText = el("label")),
                  (this.activitytype = new Droplist({
                    id: "reserve-activitytype",
                  }))
                ),
                el(
                  ".col2",
                  (this.natureOfOperationText = el("label")),
                  (this.natureOfOperation = new Droplist({
                    id: "reserve-natureofoperation",
                  }))
                )
              ),
              (this.otherGroup = el(
                ".row",
                { style: { display: "none" } },
                el(
                  ".col2",
                  (this.freeTextText = el("label")),
                  (this.freeText = el("input", {
                    id: "reserve-freetext",
                  }))
                )
              )),
              el(
                ".row",
                el(
                  ".col2",
                  (this.lowerText = el("label")),
                  (this.lower = el("input.input", {
                    id: "reserve-lower",
                    autocomplete: "off",
                    type: "number",
                    value: 0,
                  }))
                ),
                el(
                  ".col2",
                  (this.upperText = el("label")),
                  (this.upper = el("input.input", {
                    id: "reserve-upper",
                    autocomplete: "off",
                    type: "number",
                    value: 0,
                  }))
                )
              ),
              el(
                ".row",
                el(
                  ".col2",
                  (this.publicPhoneText = el("label")),
                  (this.publicPhone = el("input.input", {
                    id: "reserve-publicphone",
                    autocomplete: "off",
                  }))
                ),
                el(
                  ".col2",
                  (this.descriptionText = el("label")),
                  (this.description = el("input.input", {
                    id: "reserve-description",
                    autocomplete: "off",
                  }))
                )
              ),
              (this.errors2 = el(".errors", {
                style: { color: "red", padding: "1rem 0" },
              })),
              el(
                "div",
                { style: { textAlign: "right" } },
                (this.cancel2 = el(
                  "button.button.circle.grey",
                  { type: "reset" },
                  new Icon("arrow-left")
                )),
                (this.submitButton2 = el(
                  "button.button.circle",
                  { type: "submit" },
                  new Icon("arrow-right")
                ))
              )
            )
          )),
          (this.sendStatus = el("p"))
        )),
        (this.close = el(".close", new Icon("x")))
      )
    );
    this.close.onclick = () => {
      api.drawPlan = false;
      api.reserveAirspace = false;
      api.update();
    };
    this.cancel.onclick = this.cancel2.onclick = () => {
      if (this.phase === 2) {
        this.phase = 1;
        this.update();
        return;
      }
      api.drawPlan = true;
      api.reserveAirspace = false;
      api.update();
    };
    this.form.onsubmit = this.form2.onsubmit = async (e) => {
      e.preventDefault();

      const { BASE_URL, RELATIVE_PATH } = window.ENV;

      console.log(this.phase);

      if (this.phase === 1) {
        const errors = [];

        if (!this.phone.value) {
          this.phoneText.style.color = "red";
          errors.push(i18n("reservation.mandatory.phone"));
        } else if (!validPhone(this.phone.value)) {
          this.phoneText.style.color = "red";
          errors.push(i18n("reservation.invalid.phone"));
        } else {
          this.phoneText.style.color = "";
        }

        this.errors.textContent = "";

        for (const error of errors) {
          const $p = document.createElement("p");
          $p.textContent = error;
          this.errors.appendChild($p);
        }

        if (errors.length) {
          return;
        }

        this.phase = 2;
        if (this.content) {
          this.content.scrollTop = 0;
        }
        this.update();
      } else if (this.phase === 2) {
        const errors = [];

        if (this.activitytype.value === "select") {
          this.activitytypeText.style.color = "red";
          errors.push(i18n("reservation.mandatory.activitytype"));
        } else {
          this.activitytypeText.style.color = "";
        }

        if (this.activitytype.value === "OTHER") {
          if (!this.freeText.value) {
            errors.push(i18n("reservation.mandatory.freeText"));
          }
        }

        if (this.natureOfOperation.value === "select") {
          this.natureOfOperationText.style.color = "red";
          errors.push(i18n("reservation.mandatory.natureOfOperation"));
        } else {
          this.natureOfOperationText.style.color = "";
        }

        if (!this.publicPhone.value) {
          this.publicPhoneText.style.color = "red";
          errors.push(i18n("reservation.mandatory.publicPhone"));
        } else if (!validPhone(this.publicPhone.value)) {
          this.publicPhoneText.style.color = "red";
          errors.push(i18n("reservation.invalid.publicPhone"));
        } else {
          this.publicPhoneText.style.color = "";
        }

        this.errors2.textContent = "";

        console.log(errors);

        for (const error of errors) {
          const $p = document.createElement("p");
          $p.textContent = error;
          this.errors2.appendChild($p);
        }

        if (errors.length) {
          return;
        }

        const emailData = {};

        [
          "firstName",
          "lastName",
          "phone",
          "email",
          "startDatetime",
          "endDatetime",
          "activitytype",
          "freeText",
          "natureOfOperation",
          "lower",
          "upper",
          "publicPhone",
          "description",
        ].forEach((field) => {
          let value = this[field].value || "";

          if (field.includes("Datetime")) {
            value = new Date(this[field].value)
              .toISOString()
              .replace(".000", "");
          }

          emailData[field] = value;
        });
        emailData.coordinates = this.api.currentDrawing;
        emailData.radius = api.buffer;
        emailData.type = this.api.drawingMode;

        this.sendStatus.textContent = i18n("reservation.sending");
        this.phase = 3;
        this.update();

        if (this.content) {
          this.content.scrollTop = 0;
        }

        try {
          const response = await post(
            BASE_URL + RELATIVE_PATH + "utm/reserve",
            {
              body: JSON.stringify(emailData),
            }
          );
          this.api.reserveAirspace = false;
          this.api.update();
          this.api.fetchReservations(true);
        } catch (err) {
          this.sendStatus.textContent = i18n("reservation.error");
        }
      }
    };
  }
  async update(data = this.data) {
    this.data = data;
    const { i18n, api } = this;
    const { drawPlan } = data;
    const { user } = api;

    this.email.value = user?.email || "";
    this.phone.value = user?.phone || "";
    this.publicPhone.value = user?.phone || "";
    this.firstName.value = user?.given_name || "";
    this.lastName.value = user?.family_name || "";

    if (this.phase === 1) {
      this.form.style.display = "";
      this.form2.style.display = "none";
      this.sendStatus.style.display = "none";
    } else if (this.phase === 2) {
      this.form.style.display = "none";
      this.form2.style.display = "";
      this.sendStatus.style.display = "none";
    } else if (this.phase === 3) {
      this.form.style.display = "none";
      this.form2.style.display = "";
      this.sendStatus.style.display = "none";
    }

    this.el.style.display = drawPlan ? "none" : "";
    this.contactDetailsText.textContent = i18n("reservation.contactDetails");
    this.firstNameText.textContent = i18n("reservation.firstName");
    this.lastNameText.textContent = i18n("reservation.lastName");
    this.emailText.textContent = i18n("reservation.email");
    this.phoneText.textContent = `${i18n("reservation.phone")}*`;
    this.reservationDetailsText.textContent = i18n(
      "reservation.reservationDetails"
    );
    this.startDatetimeText.textContent = `${i18n(
      "reservation.startDatetime"
    )}*`;
    this.endDatetimeText.textContent = `${i18n("reservation.endDatetime")}*`;
    this.activitytypeText.textContent = `${i18n("reservation.activitytype")}*`;
    this.natureOfOperationText.textContent = `${i18n(
      "reservation.natureOfOperation"
    )}*`;
    this.freeTextText.textContent = i18n("reservation.freeText");
    this.descriptionText.textContent = i18n("reservation.description");
    this.lowerText.textContent = i18n("reservation.lower");
    this.upperText.textContent = i18n("reservation.upper");
    this.publicPhoneText.textContent = `${i18n("reservation.publicPhone")}*`;

    const activityType = this.activitytype.value;
    this.activitytype.options = [
      "select",
      "UAS",
      "BALLOON",
      "TETHERED BALLOON",
      "GLIDER",
      "PARAGLIDER",
      "HANG GLIDER",
      "ULTRALIGHT",
      "SKYDIVE",
      "AEROBATICS",
      "FIREWORK",
      "SHOOTING",
      "OTHER",
    ].map((value) => {
      return {
        value,
        text: i18n(`reservation.activitytype.${value}`),
      };
    });
    this.activitytype.value = activityType || "select";
    const natureOfOperation = this.natureOfOperation.value;
    this.natureOfOperation.options = [
      "select",
      "individual",
      "sportingEvent",
    ].map((value) => {
      return {
        value,
        text: i18n(`reservation.natureOfOperation.${value}`),
      };
    });
    this.natureOfOperation.value = natureOfOperation || "select";

    this.activitytype.onchange = () => {
      if (this.activitytype.value === "OTHER") {
        this.otherGroup.style.display = "";
      } else {
        this.otherGroup.style.display = "none";
      }
    };
  }
}

function validPhone(phone) {
  const validCharacters = "0123456789 ";
  let check = phone.slice();
  if (check[0] === "+") {
    check = check.slice(1);
  }
  for (let i = 0; i < check.length; i++) {
    const char = check[i];
    if (!validCharacters.includes(char)) {
      return false;
    }
  }
  return true;
}
